translator = {
	init() {
		var
			$pluginItems = $('.translatorjs_lang_item'),
			$transItems = $('.js-translator-item'),
			$activeItem = $pluginItems.filter('.translatorjs_lang_active'),
			$flag = $('.js-translator-flag');

		//Установка класса активности
		$transItems
			.filter(`[data-value="${$activeItem.data('translatorjs-lang')}"]`)
			.addClass('active');

		//Установка флага по умолчанию
		$flag.attr('src', $flag.attr('src').replace(
			'#CODE#', $activeItem.data('translatorjs-lang')
		));

		//Переключение языка
		$transItems.on('click', function(event) {
			var
				$target = $(event.currentTarget),
				value = $target.data('value');

			$pluginItems
				.filter(`[data-translatorjs-lang="${value}"]`)
				.click();
		});
	}
}



$(document).ready(function() {
	translator.init();
});